import { Component, OnInit, Input } from '@angular/core';
import { Course } from "../../courses/shared/course";
import { Syllabus } from "../shared/syllabus";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material";
import { ObjectObservable } from "../../shared/base/object-observable";
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from "../shared/message";

@Component({
  selector: 'app-syllabus-recommenders-edit',
  templateUrl: './syllabus-recommenders-edit.component.html'
})
export class SyllabusRecommendersEditComponent implements OnInit {

  @Input() course: Course;
  @Input() courseObservable:  ObjectObservable<Course>;

  constructor(
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  async addRecommender() {
    try {
      const recommender = Object.assign(new Syllabus(), {
        name: 'New'
    });

      if(!this.course.syllabus.recommenders){
        this.course.syllabus.recommenders = [];
      }
      this.course.syllabus.recommenders.push(recommender);
      await this.courseObservable.update(this.course);
    } catch (e) {
      this.handleError(e);
    }
  }

  async removeRecommenderTab(i) {
    try {
      this.course.syllabus.recommenders.splice(i, 1);
      await this.courseObservable.update(this.course);
      this.handleSuccess();
    }catch (e) {
      this.handleError(e);
    }
  }

  async onSubmit(value: Syllabus) {
    try {
      this.course.syllabus = value;
      await this.courseObservable.update(this.course);
      this.handleSuccess();
    } catch (e) {
      this.handleError(e);
    }
  }

  private handleSuccess() {
    this.openSnackBar(MESSAGE_EDIT_SUCCESS);
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-recommenders-edit/syllabus-recommenders-edit.component.ts